module.exports = __webpack_public_path__ + "img/vote-success.746b34b5.svg";